// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__Zl-FC","right":"Footer_right__11kWs","buttons":"Footer_buttons__K6xYE"};